import styles from './LoaderSmall.module.css';
import styled from "styled-components";

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const LoaderColor = styled.div`
  border-top-color:#0e3325;
`;

export default function LoaderSmall({...rest}){
    return <>
        <LoaderWrapper {...rest}>
            <LoaderColor className={styles.loader}></LoaderColor>
        </LoaderWrapper>
    </>;
}
